import { Component, OnInit } from '@angular/core';
import { BuywifiService } from '../../services/buywifi.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentPage;
  isPaymentPage = false;
  constructor(private buywifiService: BuywifiService) { }

  ngOnInit() {
    this.currentPage = this.buywifiService.getCurrentState();
  }
  getLink() {
    let url;
    if (this.currentPage === 1) {
      url = 'javascript:;';
      this.isPaymentPage = true;
    } else {
      url = 'http://www.staralliance.com';
      this.isPaymentPage = false;
    }
    return url;
  }
}
